import { render, staticRenderFns } from "./BrandAssortmentForm.vue?vue&type=template&id=68dd73c4&"
import script from "./BrandAssortmentForm.vue?vue&type=script&lang=js&"
export * from "./BrandAssortmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports